import styled from "styled-components";

export const MyMessage = styled.p`
  color: red;
  font-size: 14px;
  text-align: center;
  margin: 8px 0;
`;
